import { PracticeApp } from "./features/practice/PracticeApp";

function App() {
  return <PracticeApp />;
}

export default App;
